import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setSuccess(true);
      toast.success("Password reset successfully!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0a0a1f] via-[#1a0a3e] to-[#3a0a5c] flex items-center justify-center p-4 relative overflow-hidden">
      <img
        src="https://customer-assets.emergentagent.com/job_80904b6f-7286-4784-ad3d-292b160c5a80/artifacts/crjane52_MEGA%20CHAT%20LOGO.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 m-auto w-[85vmin] h-[85vmin] max-w-none object-contain opacity-[0.10] pointer-events-none select-none"
      />
        <div className="retro-window w-full max-w-md">
          <div className="retro-title-bar">
            <span>Error</span>
          </div>
          <div className="p-6 bg-[#C0C0C0]">
            <div className="retro-inset p-6 text-center">
              <p className="font-verdana text-sm text-red-600">Invalid reset link</p>
              <Link to="/forgot-password" className="retro-button inline-block mt-4">
                Request New Link
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0a1f] via-[#1a0a3e] to-[#3a0a5c] flex items-center justify-center p-4 relative overflow-hidden">
      <img
        src="https://customer-assets.emergentagent.com/job_80904b6f-7286-4784-ad3d-292b160c5a80/artifacts/crjane52_MEGA%20CHAT%20LOGO.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 m-auto w-[85vmin] h-[85vmin] max-w-none object-contain opacity-[0.10] pointer-events-none select-none"
      />
      <div className="retro-window w-full max-w-md" data-testid="reset-password-window">
        <div className="retro-title-bar">
          <span>MEGA! Chat - Reset Password</span>
        </div>
        
        <div className="p-6 bg-[#C0C0C0]">
          <div className="text-center mb-6">
            <h1 className="yahoo-logo text-4xl mb-2">MEGA!</h1>
            <p className="font-verdana text-sm text-[#7B0099] font-bold">Create New Password</p>
          </div>

          {success ? (
            <div className="retro-inset p-6 text-center">
              <div className="text-4xl mb-4">✓</div>
              <p className="font-verdana text-sm text-green-700 font-bold mb-4">
                Password reset successfully!
              </p>
              <Link to="/login" className="retro-button inline-block" data-testid="reset-login-btn">
                Sign In Now
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block font-verdana text-sm mb-1">New Password:</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="retro-input w-full"
                  required
                  minLength={6}
                  data-testid="reset-password-input"
                />
              </div>

              <div>
                <label className="block font-verdana text-sm mb-1">Confirm New Password:</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="retro-input w-full"
                  required
                  data-testid="reset-confirm-password-input"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="retro-button w-full py-2"
                data-testid="reset-submit-btn"
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          )}

          {/* Credit */}
          <div className="mt-4 text-center">
            <p className="font-arial text-xs text-[#808080]">created by mr_fuker</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
